// PDP gallery: one big image, arrows, dots, and a thumbnail strip.
//
// Sep 16: colour photos are hidden behind their swatch, so this file counts VISIBLE images, not
// gal.children.length — otherwise the Sculpt Legging read "1/16" under sixteen dots while only
// seven images were reachable.
//
// Sep 17a: desktop used to stack every photo in a two-column mosaic, so there was no hero shot
// and the page simply got longer. Desktop now uses the same one-up carousel as mobile and this
// file builds a thumbnail strip beneath it — click a thumb, the big image changes.
//
// Sep 17b: THE GALLERY OPENED ON THE LAST PHOTO. On the Sculpt Legging a fresh load with zero
// interaction read "7/7" with scrollLeft already at maximum. Cause: the ten colour photos are
// hidden AFTER first layout, and the browser keeps its scroll anchored to what was, at that
// moment, the last child. CSS overflow-anchor alone did not clear it. The first build now
// explicitly parks the carousel at image 1 — unless the URL names a variant, in which case we
// open on that shade's photo instead.
//
// Two things to keep in mind when editing:
//   * the strip must be appended INSIDE .galwrap. .pdp is a two-column grid on desktop, so a
//     sibling of .galwrap becomes its own grid cell and lands beside the buy column.
//   * write the arrow glyphs as real characters. A "\\u2039" escape survives the theme upload
//     literally and renders as the text \\u2039 on the button.
(function () {
  function init() {
    var gal = document.getElementById('gal');
    if (!gal || gal.dataset.bbInit) return;
    gal.dataset.bbInit = '1';
    var wrap = gal.parentNode;                 // .galwrap
    if (gal.children.length < 2) return;

    var first = true;
    var deepLinked = /[?&]variant=/.test(location.search);

    function vis() { return [].slice.call(gal.querySelectorAll('img:not([hidden])')); }

    var dots = document.createElement('div');
    dots.className = 'galdots';
    wrap.appendChild(dots);

    var strip = document.createElement('div');
    strip.className = 'galthumbs';
    wrap.appendChild(strip);                   // inside .galwrap, not after it

    function mk(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'galnav ' + dir;
      b.setAttribute('aria-label', label); b.textContent = glyph;
      b.addEventListener('click', function () {
        gal.scrollBy({ left: (dir === 'next' ? 1 : -1) * gal.clientWidth, behavior: 'smooth' });
      });
      wrap.appendChild(b); return b;
    }
    mk('prev', 'Previous image', '‹');
    mk('next', 'Next image', '›');

    function current() {
      return gal.clientWidth ? Math.round(gal.scrollLeft / gal.clientWidth) : 0;
    }

    function build() {
      var imgs = vis(), n = imgs.length;

      while (dots.children.length > n) dots.removeChild(dots.lastChild);
      while (dots.children.length < n) dots.appendChild(document.createElement('i'));
      dots.style.display = n > 1 ? '' : 'none';

      strip.innerHTML = '';
      if (n > 1) {
        imgs.forEach(function (im, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'galthumb';
          b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + n);
          var t = document.createElement('img');
          t.src = im.currentSrc || im.src;
          t.alt = '';
          t.loading = 'lazy';
          b.appendChild(t);
          b.addEventListener('click', function () {
            gal.scrollTo({ left: i * gal.clientWidth, behavior: 'smooth' });
          });
          strip.appendChild(b);
        });
      }

      // first pass: land on image 1, not wherever the scroll anchor left us
      if (first && !deepLinked) {
        gal.scrollLeft = 0;
        requestAnimationFrame(function () { gal.scrollLeft = 0; paint(); });
      }
      first = false;
      paint();
    }

    function paint() {
      var n = vis().length, i = current();
      if (i > n - 1) i = n - 1;
      if (i < 0) i = 0;
      for (var k = 0; k < dots.children.length; k++)
        dots.children[k].className = (k === i ? 'on' : '');
      for (var j = 0; j < strip.children.length; j++)
        strip.children[j].setAttribute('aria-current', j === i ? 'true' : 'false');
      var c = document.getElementById('galn');
      if (c) c.textContent = (i + 1) + '/' + n;
    }

    gal.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);

    if (window.MutationObserver) {
      new MutationObserver(build).observe(gal, {
        attributes: true, attributeFilter: ['hidden'], subtree: true
      });
    }

    build();

    // deep link: an ad points at a variant, so open on that shade's photo
    if (deepLinked) {
      var chosen = document.querySelector('.opts .opt[aria-checked="true"]');
      var want = chosen && chosen.getAttribute('data-shade');
      if (want && window.CSS && window.CSS.escape) {
        var shot = gal.querySelector('img[data-shade-of="' + window.CSS.escape(want) + '"]:not([hidden])');
        if (shot) { shot.scrollIntoView({ block: 'nearest', inline: 'center' }); paint(); }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();